export default __webpack_public_path__ + "static/media/kallithea.dec08970.svg";